module.exports = __webpack_public_path__ + "img/11.2c9c623e.jpg";